<template>
  <div class="guideIndex">
    <div class="redbooklogo_box">
      <img class="redbooklogo" :src="img.redbooklogo">
    </div>
    <div class="guide_bk_box">
      <div class="guide_cell_box">
        <div class="guide_cell">
          <img class="red_avatar" :src="img.lzf">
          <div class="guide_cell_text">
            <div class="red_title_box">
              <div class="red_title">凌志范儿</div>
              <div class="red_num">小红书号:198610_Lexus</div>
            </div>
            <div class="red_content">凌志范儿官方账号，小红书分范儿</div>
          </div>
          <img class="btn_img" @click="openPage('凌志范儿','https://www.xiaohongshu.com/user/profile/6321785f0000000023024895?xhsshare=CopyLink&appuid=5e735290000000000100b05f&apptime=1669016766')" :src="img.redbook_btn">
        </div>
        <div class="guide_cell">
          <img class="red_avatar" :src="img.ljy">
          <div class="guide_cell_text">
            <div class="red_title_box">
              <div class="red_title">雷家音</div>
              <div class="red_num">小红书号：628656390</div>
            </div>
            <div class="red_content">凌志范儿创始人，高端玩家</div>
          </div>
          <img class="btn_img" @click="openPage('雷家音','https://www.xiaohongshu.com/user/profile/557558c567bc65573967d15e?xhsshare=CopyLink&appuid=5e735290000000000100b05f&apptime=1669016853')" :src="img.redbook_btn">
        </div>
        <div class="guide_cell">
          <img class="red_avatar" :src="img.lzl">
          <div class="guide_cell_text">
            <div class="red_title_box">
              <div class="red_title">凌志灵</div>
              <div class="red_num">小红书号：346887193</div>
            </div>
            <div class="red_content">凌志范儿的美女车主们，颜值即正义</div>
          </div>
          <img class="btn_img" @click="openPage('凌志灵','https://www.xiaohongshu.com/user/profile/5ef02d0c0000000001001bfb?xhsshare=CopyLink&appuid=5e735290000000000100b05f&apptime=1669016690')" :src="img.redbook_btn">
        </div>
        <div class="guide_cell">
          <img class="red_avatar" :src="img.ldd">
          <div class="guide_cell_text">
            <div class="red_title_box">
              <div class="red_title">超音速小雷</div>
              <div class="red_num">小红书号：195214588</div>
            </div>
            <div class="red_content">凌志范儿玩车达人，勤钻研懂技术爱生活</div>
          </div>
          <img class="btn_img" @click="openPage('超音速小雷','https://www.xiaohongshu.com/user/profile/5e80adf300000000010043a1?xhsshare=CopyLink&appuid=5e735290000000000100b05f&apptime=1669016904')" :src="img.redbook_btn">
        </div>
        <div class="red_bottom_text">
          <div class="">#抓紧关注成为我们的头号粉丝吧#</div>
          <div style="margin-top: 6px;">关注全部4个账号更有好礼相送哦</div>
        </div>
      </div>
    </div>  
  </div>
</template>

<script>
  import common from '../../api/common';
  import content from '../../api/content';
  import wxShare from '../../api/wxShare';
  import { mapState } from 'vuex';
  export default {
    data () {
      return {
        scene:0,
        img:{
          lzf: require('../../assets/img/redbook/lzf.png'),
          ljy: require('../../assets/img/redbook/ljy.png'),
          lzl: require('../../assets/img/redbook/lzl.png'),
          ldd: require('../../assets/img/redbook/ldd.png'),
          redbook_btn: require('../../assets/img/redbook/redbook_btn.png'),
          redbooklogo: require('../../assets/img/redbook/redbooklogo.png'),
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      var params={
        event_code: '小红书博主',
        event_id: '',
        title: '',
        value: '',
        path: '/redblogger',
        user_id: '',
        source: this.source,
        source_page: '小红书博主'
      }
      this.toBurialPoint(params)
      var dataForWeixin= {
        title:'凌志范儿拍了拍你，邀请你加入',
        description:'关注齐我们的4个账号，100%有好礼相送',
        url:'https://m.motortime.com/redblogger',
        pic_url:'https://pic.motortime.com/Uploadfile/Picture/90/2c/902c7ddecf93bc71ba6940f841993656.jpg'
      }
      content.getShare({url:'https://m.motortime.com/redblogger'}).then(res => {
        if(res.data.state == 1) {
         wxShare.getJSSDK(res.data.data, dataForWeixin)
       }
     })
    },
    methods: {
      openPage(type,url){
        var params={
          event_code: '小红书博主-'+type,
          event_id: '',
          title: '',
          value: '',
          path: '/redblogger',
          user_id: '',
          source: this.source,
          source_page: '小红书博主-'+type
        }
        this.toBurialPoint(params)
        window.open(url)
      },
      toBurialPoint (params) {
        common.BurialPoint(params).then(res => {
          if(res.data.state == 1) {
            console.log('埋点成功')
          }
        })
      },
    }
  };
</script>

<style lang="scss">
  .guideIndex {
    overflow: hidden;
    overflow-y: hidden;
    overflow-x: hidden;
    .redbooklogo_box{
      width: 100%;
      height: 45px;
      margin-top: 30px;
      text-align: center;
    }
    .redbooklogo{
      width: 130px;
      height: 45px;
    }
    .guide_bk_box{
      width: 100%;
      height: calc(100vh - 105px);
      margin-top: 30px;
      border-top-left-radius:35px;
      border-top-right-radius:35px;
      background-image: linear-gradient( to bottom , #FF2444,#FF8F9F);
    }
    .guide_cell_box{
      padding-top: 20px;
      .guide_cell{
        color: #ffffff;
        display: flex;
        align-items:center;
        padding:20px 0;
        margin: 0 15px;
        border-bottom:0.5px solid #E5E5E5;

        .red_avatar{
          width: 66px;
          height: 66px;
        }
        .guide_cell_text{
          flex: 1;
          margin-left: 8px;
          .red_title_box{
            display: flex;
            align-items:flex-end;
            margin-bottom: 6px;
            .red_title{
              font-size: 18px;
              font-weight: bold;
            }
            .red_num{
              font-size: 0.2rem;
              margin-left: 5px;
              margin-bottom: 2px;
            }
          }
          .red_content{
            font-size: 10px;
          }
        }
        .btn_img{
          width: 58px;
          height: 24px;
        }

      }
      .red_bottom_text{
        color: #ffffff;
        font-size: 13px;
        margin-top: 50px;
        text-align: center;
        letter-spacing:3px;
      }
    }
    
  }
</style>
